var O = Object.defineProperty;
var R = (e, t, i) => t in e ? O(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i;
var a = (e, t, i) => R(e, typeof t != "symbol" ? t + "" : t, i);
import { isValid as u, parse as h, format as S } from "date-fns";
import { es as M, enUS as T } from "date-fns/locale";
import { useState as w, useCallback as y, useEffect as U } from "react";
import { z as n } from "zod";
import { AuthError as v } from "@aws-amplify/auth";
import * as o from "@sentry/react";
import { Amplify as L } from "aws-amplify";
function N(e) {
  const t = e.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (t) {
    const [, i, s, r] = t;
    return new Date(parseInt(i, 10), parseInt(s, 10) - 1, parseInt(r, 10));
  }
  return new Date(e);
}
const l = {
  API: "yyyy-MM-dd",
  DISPLAY: "yyyy-MM-dd"
}, Q = {
  // Convert from display format to API format
  toAPIFormat(e) {
    if (!e) return "";
    if (e.match(/^\d{4}-\d{2}-\d{2}$/)) return e;
    const t = h(e, l.DISPLAY, /* @__PURE__ */ new Date());
    return u(t) ? S(t, l.API) : "";
  },
  // Convert from API format to display format
  toDisplayFormat(e) {
    if (!e) return "";
    if (e.match(/^\d{2}\.\d{2}\.\d{4}$/)) return e;
    const t = N(e);
    return u(t) ? S(t, l.DISPLAY) : "";
  },
  // Validate date string in display format
  isValidDisplayDate(e) {
    if (!e) return !1;
    const t = h(e, l.DISPLAY, /* @__PURE__ */ new Date());
    return u(t) && t <= /* @__PURE__ */ new Date();
  },
  // Parse any format to Date object
  parseAnyFormat(e) {
    if (!e) return null;
    let t = N(e);
    return u(t) ? t : (t = h(e, l.DISPLAY, /* @__PURE__ */ new Date()), u(t) ? t : null);
  }
};
var D = /* @__PURE__ */ ((e) => (e.IMAGE = "IMAGE", e.PDF = "PDF", e.EXTERNAL_URL = "EXTERNAL_URL", e.UNKNOWN = "UNKNOWN", e))(D || {});
const I = (e) => {
  if (!e) return "UNKNOWN";
  switch (e) {
    case "IMAGE":
      return "IMAGE";
    case "PDF":
      return "PDF";
    case "EXTERNAL_URL":
      return "EXTERNAL_URL";
    default:
      return "UNKNOWN";
  }
};
function Z(e) {
  return I(e) === "IMAGE";
}
function J(e) {
  return I(e) === "PDF";
}
function ee(e) {
  return I(e) === "EXTERNAL_URL";
}
const A = "preferred_dashboard_view", te = () => localStorage.getItem(A) || "listings", ie = (e) => {
  localStorage.setItem(A, e);
};
class x {
  constructor() {
    a(this, "notificationAudio", null);
    a(this, "isInitialized", !1);
    a(this, "audioUnlocked", !1);
  }
  /**
   * Initialize the audio element
   * Should be called after user interaction to comply with browser autoplay policies
   */
  initialize() {
    if (!this.isInitialized)
      try {
        this.notificationAudio = new Audio("/notification.wav"), this.notificationAudio.volume = 1, this.notificationAudio.preload = "auto", this.notificationAudio.load(), this.isInitialized = !0, console.debug("Sound manager initialized");
      } catch (t) {
        console.error("Failed to initialize sound manager:", t);
      }
  }
  /**
   * Register a one-time listener that unlocks audio on the user's first
   * interaction (click, tap, or key press). Browsers require a user gesture
   * before Audio.play() is allowed.
   */
  initAudioUnlock() {
    const t = ["pointerdown", "keydown"], i = () => {
      this.unlockAudio(), t.forEach((s) => document.removeEventListener(s, i));
    };
    t.forEach((s) => document.addEventListener(s, i, { once: !1 }));
  }
  unlockAudio() {
    if (this.audioUnlocked || (this.isInitialized || this.initialize(), !this.notificationAudio)) return;
    const t = this.notificationAudio.volume;
    this.notificationAudio.volume = 0, this.notificationAudio.play().then(() => {
      this.notificationAudio.pause(), this.notificationAudio.currentTime = 0, this.notificationAudio.volume = t, this.audioUnlocked = !0, console.debug("Sound manager audio unlocked");
    }).catch(() => {
      this.notificationAudio.volume = t;
    });
  }
  /**
   * Play the notification sound
   * Works even when tab is in background by using a persistent audio element
   * @returns Promise that resolves when sound starts playing
   */
  async playNotification() {
    try {
      if (this.isInitialized || this.initialize(), !this.notificationAudio)
        throw new Error("Audio element not initialized");
      this.notificationAudio.currentTime = 0, await this.notificationAudio.play(), console.debug("Notification sound played");
    } catch (t) {
      console.warn("Failed to play notification sound:", t);
    }
  }
  /**
   * Set the volume for notification sounds
   * @param volume - Volume level between 0 and 1
   */
  setVolume(t) {
    this.notificationAudio && (this.notificationAudio.volume = Math.max(0, Math.min(1, t)));
  }
  /**
   * Check if sound is initialized
   */
  isReady() {
    return this.isInitialized;
  }
}
const m = new x(), se = {
  playNotification: () => m.playNotification(),
  initialize: () => m.initialize(),
  initAudioUnlock: () => m.initAudioUnlock(),
  setVolume: (e) => m.setVolume(e),
  isReady: () => m.isReady()
}, ne = (e) => {
  const t = document.getElementById(e);
  if (t) {
    const i = document.querySelector("header"), s = i ? i.offsetHeight : 0, d = t.getBoundingClientRect().top + window.pageYOffset - s;
    window.scrollTo({
      top: d,
      behavior: "smooth"
    });
  }
}, oe = {
  h1: {
    size: "75px",
    lineHeight: "1.2",
    letterSpacing: "-0.02em",
    fontWeight: 700
  },
  h2: {
    size: "60px",
    lineHeight: "1.2",
    letterSpacing: "-0.02em",
    fontWeight: 700
  },
  h3: {
    size: "45px",
    lineHeight: "1.2",
    letterSpacing: "-0.01em",
    fontWeight: 700
  },
  h4: {
    size: "30px",
    lineHeight: "1.2",
    fontWeight: 700
  },
  body: {
    size: "16px",
    lineHeight: "1.5",
    fontWeight: 400
  },
  bodyLarge: {
    size: "18px",
    lineHeight: "1.5",
    fontWeight: 400
  },
  bodySmall: {
    size: "14px",
    lineHeight: "1.5",
    fontWeight: 400
  },
  caption: {
    size: "12px",
    lineHeight: "1.5",
    fontWeight: 400
  }
}, F = {
  en: T,
  es: M
  // …add more mappings when you introduce new languages
};
function re(e) {
  const t = (e || navigator.language).split("-")[0] ?? "en";
  return F[t] ?? T;
}
const ae = "guardian_device_trust", ce = "cognitoDeviceKey", de = {
  USER_SRP_AUTH: "USER_SRP_AUTH",
  USER_PASSWORD_AUTH: "USER_PASSWORD_AUTH",
  // Note: Disables device tracking
  CUSTOM_WITH_SRP: "CUSTOM_WITH_SRP",
  CUSTOM_WITHOUT_SRP: "CUSTOM_WITHOUT_SRP",
  USER_AUTH: "USER_AUTH"
}, f = {
  minLength: 8,
  requireUppercase: !0,
  requireLowercase: !0,
  requireNumbers: !0,
  requireSpecialChars: !1
}, ue = {
  INVALID_CREDENTIALS: "InvalidCredentialsException",
  USER_NOT_CONFIRMED: "UserNotConfirmedException",
  USER_NOT_FOUND: "UserNotFoundException",
  USERNAME_EXISTS: "UsernameExistsException",
  CODE_MISMATCH: "CodeMismatchException",
  EXPIRED_CODE: "ExpiredCodeException",
  LIMIT_EXCEEDED: "LimitExceededException",
  SESSION_EXPIRED: "SessionExpiredException",
  INVALID_PARAMETER: "InvalidParameterException",
  TOO_MANY_REQUESTS: "TooManyRequestsException"
}, W = {
  NotAuthorizedException: "Invalid email or password",
  UserNotConfirmedException: "Please verify your email address",
  UserNotFoundException: "No account found with this email",
  UsernameExistsException: "An account with this email already exists",
  CodeMismatchException: "Invalid verification code",
  ExpiredCodeException: "Verification code has expired",
  LimitExceededException: "Too many attempts. Please try again later",
  InvalidPasswordException: "Password does not meet requirements",
  InvalidParameterException: "Invalid parameters provided",
  TooManyRequestsException: "Too many requests. Please try again later"
}, le = {
  // Email MFA challenges
  EMAIL_CODE: "CONFIRM_SIGN_IN_WITH_EMAIL_CODE",
  EMAIL_OTP: "EMAIL_OTP",
  EMAIL_CUSTOM: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
  // SMS MFA challenges
  SMS: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
  SMS_CODE: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
  // TOTP MFA challenges
  TOTP: "CONFIRM_SIGN_IN_WITH_TOTP_CODE",
  TOTP_MFA: "CONFIRM_SIGN_IN_WITH_TOTP_MFA_CODE",
  SOFTWARE_TOKEN: "CONFIRM_SIGN_IN_WITH_SOFTWARE_TOKEN_MFA_CODE",
  // New password required
  NEW_PASSWORD: "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
  // Custom challenges
  CUSTOM_CHALLENGE: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
  // MFA selection
  MFA_SELECTION: "CONTINUE_SIGN_IN_WITH_MFA_SELECTION",
  MFA_SETUP_SELECTION: "CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION",
  // TOTP setup
  TOTP_SETUP: "CONTINUE_SIGN_IN_WITH_TOTP_SETUP",
  EMAIL_SETUP: "CONTINUE_SIGN_IN_WITH_EMAIL_SETUP"
}, me = "trusted_device_status", he = "mfa_session_data", Ee = 6, fe = 5, ge = 30, Ie = 3, _e = 30, Se = () => {
  const [e, t] = w({
    isValid: !1,
    hasMinLength: !1,
    hasUppercase: !1,
    hasLowercase: !1,
    hasNumber: !1,
    hasSpecialChar: !1,
    score: 0
  }), i = y((s) => {
    const r = {
      hasMinLength: s.length >= f.minLength,
      hasUppercase: /[A-Z]/.test(s),
      hasLowercase: /[a-z]/.test(s),
      hasNumber: /\d/.test(s),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(s),
      score: 0,
      isValid: !1
    };
    let d = 0;
    return Object.entries(r).forEach(([_, C]) => {
      _ !== "score" && _ !== "isValid" && C && (d += 20);
    }), r.score = d, r.isValid = d >= 60, t(r), r;
  }, []);
  return {
    strength: e,
    validatePassword: i
  };
};
function H(e) {
  return typeof window > "u" ? !1 : window.matchMedia(e).matches;
}
function Ne(e) {
  const [t, i] = w(() => H(e));
  return U(() => {
    const s = window.matchMedia(e);
    i(s.matches);
    const r = () => i(s.matches);
    return s.addEventListener("change", r), () => s.removeEventListener("change", r);
  }, [e]), t;
}
const P = n.string().min(f.minLength, {
  message: `Password must be at least ${f.minLength} characters`
}).regex(/[a-z]/, {
  message: "Password must contain at least one lowercase letter"
}).regex(/[A-Z]/, {
  message: "Password must contain at least one uppercase letter"
}).regex(/\d/, { message: "Password must contain at least one number" }), pe = n.object({
  email: n.string().email({ message: "Invalid email address" }),
  password: P,
  confirmPassword: n.string(),
  firstName: n.string().min(2, { message: "First name must be at least 2 characters" }),
  lastName: n.string().min(2, { message: "Last name must be at least 2 characters" })
}).refine((e) => e.password === e.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"]
}), Te = n.object({
  email: n.string().email({ message: "Invalid email address" }),
  password: n.string().min(1, { message: "Password is required" })
}), we = n.object({
  email: n.string().email({ message: "Invalid email address" })
}), Ae = n.object({
  code: n.string().min(1, "Verification code is required"),
  newPassword: n.string().min(8, "Password must be at least 8 characters").regex(/[A-Z]/, "Password must contain at least one uppercase letter").regex(/[a-z]/, "Password must contain at least one lowercase letter").regex(/[0-9]/, "Password must contain at least one number"),
  confirmPassword: n.string()
}).refine((e) => e.newPassword === e.confirmPassword, {
  message: "Passwords must match",
  path: ["confirmPassword"]
}), Pe = n.object({
  code: n.string().min(6, { message: "Invalid confirmation code" })
}), Ce = n.object({
  currentPassword: n.string().min(1, "Current password is required"),
  newPassword: n.string().min(8, "Password must be at least 8 characters").regex(/[A-Z]/, "Password must contain at least one uppercase letter").regex(/[a-z]/, "Password must contain at least one lowercase letter").regex(/[0-9]/, "Password must contain at least one number"),
  confirmPassword: n.string().min(1, "Please confirm your password")
}).refine((e) => e.newPassword === e.confirmPassword, {
  message: "Passwords do not match",
  path: ["confirmPassword"]
}), Oe = n.object({
  newPassword: P,
  confirmPassword: n.string()
}).refine((e) => e.newPassword === e.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"]
});
class p extends Error {
  constructor(t, i, s) {
    super(i), this.code = t, this.message = i, this.originalError = s, this.name = "AuthenticationError";
  }
}
const Re = (e) => {
  if (e instanceof v) {
    const t = W[e.name] || e.message;
    return new p(e.name, t, e);
  }
  return new p(
    "UnknownError",
    "An unexpected authentication error occurred",
    e instanceof Error ? e : void 0
  );
}, Me = {
  save(e) {
    localStorage.setItem("unconfirmedAccount", e);
  },
  get() {
    return localStorage.getItem("unconfirmedAccount");
  },
  clear() {
    localStorage.removeItem("unconfirmedAccount");
  }
};
var b = /* @__PURE__ */ ((e) => (e.LOW = "low", e.MEDIUM = "medium", e.HIGH = "high", e.CRITICAL = "critical", e))(b || {}), V = /* @__PURE__ */ ((e) => (e.NETWORK = "network", e.AUTH = "auth", e.VALIDATION = "validation", e.SERVER = "server", e.TIMEOUT = "timeout", e.RATE_LIMIT = "rate_limit", e.NOT_FOUND = "not_found", e.PERMISSION = "permission", e))(V || {});
class E {
  static classify(t, i) {
    const s = {
      category: "network",
      severity: "medium",
      isRetryable: !0,
      shouldShowToast: !0,
      originalError: t,
      endpoint: i
    };
    return this.isAxiosError(t) ? this.classifyAxiosError(t, s) : t instanceof Error ? this.classifyByErrorMessage(t, s) : s;
  }
  static classifyByErrorMessage(t, i) {
    const s = t.message.toLowerCase();
    return s.includes("failed to fetch") || s.includes("network error") || s.includes("connection refused") ? {
      ...i,
      category: "network",
      severity: this.getNetworkErrorSeverity(i.endpoint),
      isRetryable: !0,
      shouldShowToast: this.shouldShowNetworkToast(i.endpoint),
      userMessage: this.getNetworkErrorMessage(i.endpoint)
    } : s.includes("timeout") || s.includes("abort") ? {
      ...i,
      category: "timeout",
      severity: this.getTimeoutSeverity(i.endpoint),
      isRetryable: !0,
      shouldShowToast: !this.isNonCriticalEndpoint(i.endpoint)
    } : i;
  }
  static classifyAxiosError(t, i) {
    var r;
    const s = (r = t.response) == null ? void 0 : r.status;
    if (!s)
      return {
        ...i,
        category: "network",
        severity: this.getNetworkErrorSeverity(i.endpoint),
        isRetryable: !0,
        shouldShowToast: this.shouldShowNetworkToast(i.endpoint)
      };
    switch (!0) {
      case s === 401:
        return {
          ...i,
          category: "auth",
          severity: "high",
          isRetryable: !1,
          shouldShowToast: !1
          // Handle auth errors separately
        };
      case s === 403:
        return {
          ...i,
          category: "permission",
          severity: "medium",
          isRetryable: !1,
          // Don't show toast for permission-sensitive endpoints (user likely lacks permission)
          shouldShowToast: !this.isPermissionSensitiveEndpoint(i.endpoint)
        };
      case s === 404:
        return {
          ...i,
          category: "not_found",
          severity: this.isNonCriticalEndpoint(i.endpoint) ? "low" : "medium",
          isRetryable: !1,
          shouldShowToast: !this.isNonCriticalEndpoint(i.endpoint)
        };
      case s === 429:
        return {
          ...i,
          category: "rate_limit",
          severity: "medium",
          isRetryable: !0,
          shouldShowToast: !0
        };
      case (s >= 400 && s < 500):
        return {
          ...i,
          category: "validation",
          severity: "medium",
          isRetryable: !1,
          // Don't show toast for permission-sensitive endpoints on 400 errors (likely permission issues)
          shouldShowToast: !this.isPermissionSensitiveEndpoint(i.endpoint)
        };
      case s >= 500:
        return {
          ...i,
          category: "server",
          severity: this.isCriticalEndpoint(i.endpoint) ? "high" : "medium",
          isRetryable: !0,
          shouldShowToast: !0
        };
      default:
        return i;
    }
  }
  static isAxiosError(t) {
    return (t == null ? void 0 : t.isAxiosError) === !0;
  }
  static isNonCriticalEndpoint(t) {
    return t ? this.NON_CRITICAL_ENDPOINTS.some((i) => t.includes(i)) : !1;
  }
  static isCriticalEndpoint(t) {
    return t ? this.CRITICAL_ENDPOINTS.some((i) => t.includes(i)) : !1;
  }
  static isPermissionSensitiveEndpoint(t) {
    return t ? this.PERMISSION_SENSITIVE_ENDPOINTS.some((i) => t.includes(i)) : !1;
  }
  static getNetworkErrorSeverity(t) {
    return this.isCriticalEndpoint(t) ? "high" : this.isNonCriticalEndpoint(t) ? "low" : "medium";
  }
  static getTimeoutSeverity(t) {
    return this.isCriticalEndpoint(t) ? "high" : "low";
  }
  static shouldShowNetworkToast(t) {
    return !this.isNonCriticalEndpoint(t);
  }
  static getNetworkErrorMessage(t) {
    return this.isNonCriticalEndpoint(t) ? "Some features may not be up to date" : "Connection issue detected. Please check your internet connection.";
  }
}
a(E, "NON_CRITICAL_ENDPOINTS", [
  "/activities/unread/count",
  "/notifications/count",
  "/stats/summary",
  "/health",
  "/ping"
]), a(E, "CRITICAL_ENDPOINTS", [
  "/auth/",
  "/profile",
  "/users/me"
]), // Endpoints that should suppress toast errors on 400/403 (permission issues)
a(E, "PERMISSION_SENSITIVE_ENDPOINTS", [
  "/calendar/form-present-between-dates",
  "/forms/calendar",
  "/listings",
  "/forms"
]);
class k extends Error {
  constructor(t = "Failed to connect to the server") {
    super(t), this.name = "ConnectionError";
  }
}
const z = (e) => e instanceof Error ? e.message.includes("Failed to fetch") || e.message.includes("Network Error") || e.message.includes("CONNECTION_REFUSED") || e.message.includes("ECONNREFUSED") || e.message.toLowerCase().includes("network") || e.message.includes("timeout") || e.message.includes("abort") || e.message.includes("Failed to connect") || e.name && [
  "NetworkError",
  "AbortError",
  "TimeoutError",
  "ConnectionError"
].includes(e.name) || e instanceof k : !1, ye = (e) => ({
  name: "CONNECTION_ERROR",
  code: 0,
  message: z(e) ? e.message : "Failed to connect to the server",
  errorId: "CONN001"
}), Ue = (e) => {
  if (!e) {
    o.setUser(null);
    return;
  }
  o.setUser({
    id: e.userId,
    // Consider hashing email or using a unique identifier instead
    email: e.email ? G(e.email) : void 0
  }), o.setContext("user_info", {
    role: e.role,
    hasEmail: !!e.email
  });
}, ve = (e) => {
  o.setContext("form_context", {
    formId: e.formId,
    listingId: e.listingId,
    currentStep: e.step,
    totalSteps: e.totalSteps
  });
}, Le = () => {
  o.setContext("form_context", null);
}, De = (e, t) => {
  o.addBreadcrumb({
    category: "form",
    message: `Form step: ${e}`,
    level: "info",
    data: {
      step: e,
      ...t
    }
  });
}, xe = (e, t) => {
  o.addBreadcrumb({
    category: "navigation",
    message: `Navigated from ${e} to ${t}`,
    level: "info",
    data: { from: e, to: t }
  });
}, Fe = (e, t) => {
  o.addBreadcrumb({
    category: "auth",
    message: e,
    level: "info",
    data: t
  });
}, We = (e, t, i, s) => {
  o.addBreadcrumb({
    category: "api",
    message: `${e} ${t}`,
    level: s ? "error" : "info",
    data: {
      method: e,
      url: t,
      status: i,
      error: s
    }
  });
}, He = (e, t) => {
  o.addBreadcrumb({
    category: "user_action",
    message: e,
    level: "info",
    data: t
  });
}, be = (e, t) => {
  o.addBreadcrumb({
    category: "validation",
    message: `Validation error on ${e}`,
    level: "warning",
    data: {
      field: e,
      error: t
    }
  });
}, Ve = (e, t, i, s) => {
  o.addBreadcrumb({
    category: "file_upload",
    message: `File upload: ${e}`,
    level: s ? "info" : "error",
    data: {
      fileName: e,
      fileSize: t,
      fileType: i,
      success: s
    }
  });
}, ke = (e, t) => {
  t && o.setContext("error_context", t), o.captureException(e);
}, ze = (e, t = "info") => {
  o.captureMessage(e, t);
};
function G(e) {
  let t = 0;
  for (let i = 0; i < e.length; i++) {
    const s = e.charCodeAt(i);
    t = (t << 5) - t + s, t = t & t;
  }
  return `user_${Math.abs(t)}`;
}
const c = class c {
  constructor() {
    a(this, "isConfigured", !1);
  }
  static getInstance() {
    return c.instance || (c.instance = new c()), c.instance;
  }
  configure(t) {
    if (this.isConfigured) {
      console.warn("AWS is already configured");
      return;
    }
    this.validateParams(t);
    const i = {
      Auth: {
        Cognito: {
          userPoolId: t.userPoolId,
          userPoolClientId: t.userPoolClientId,
          region: t.region,
          authenticationFlowType: "USER_SRP_AUTH",
          signUpVerificationMethod: "code",
          loginWith: {
            email: !0,
            phone: !1,
            username: !1
          },
          passwordFormat: {
            minLength: 8,
            requireLowercase: !0,
            requireUppercase: !0,
            requireNumbers: !0,
            requireSpecialCharacters: !1
          }
        }
      }
    };
    try {
      L.configure(i), this.isConfigured = !0, console.info("AWS configuration completed successfully");
    } catch (s) {
      throw console.error("Failed to configure AWS:", s), new Error("AWS configuration failed");
    }
  }
  validateParams(t) {
    const i = [];
    if (t.region || i.push("region"), t.userPoolId || i.push("userPoolId"), t.userPoolClientId || i.push("userPoolClientId"), i.length > 0)
      throw new Error(
        `Missing required AWS config parameters: ${i.join(", ")}`
      );
  }
  isAWSConfigured() {
    return this.isConfigured;
  }
};
a(c, "instance");
let g = c;
const Ge = g.getInstance();
export {
  ue as AUTH_ERROR_CODES,
  de as AUTH_FLOW_TYPES,
  W as AuthErrorMessages,
  p as AuthenticationError,
  k as ConnectionError,
  ce as DEVICE_KEY_STORAGE,
  me as DEVICE_STORAGE_KEY,
  ge as DEVICE_TRUST_DURATION_DAYS,
  ae as DEVICE_TRUST_KEY,
  l as DateFormats,
  V as ErrorCategory,
  E as ErrorClassifier,
  b as ErrorSeverity,
  D as FileKind,
  Ie as MAX_MFA_ATTEMPTS,
  le as MFA_CHALLENGE_TYPES,
  fe as MFA_CODE_EXPIRY_MINUTES,
  Ee as MFA_CODE_LENGTH,
  _e as MFA_RETRY_DELAY_SECONDS,
  he as MFA_SESSION_KEY,
  f as PASSWORD_REQUIREMENTS,
  We as addApiBreadcrumb,
  Fe as addAuthBreadcrumb,
  Ve as addFileUploadBreadcrumb,
  De as addFormSubmissionBreadcrumb,
  xe as addNavigationBreadcrumb,
  He as addUserActionBreadcrumb,
  be as addValidationErrorBreadcrumb,
  Ge as awsConfig,
  ke as captureException,
  ze as captureMessage,
  Ce as changePasswordSchema,
  Le as clearSentryFormContext,
  Pe as confirmSignUpSchema,
  ye as createConnectionError,
  Q as dateUtils,
  Re as enhancedAuthErrorHandler,
  we as forgotPasswordSchema,
  re as getDateFnsLocale,
  I as getFileKind,
  te as getPreferredDashboardView,
  z as isConnectionError,
  ee as isExternalUrl,
  Z as isImage,
  J as isPdf,
  Oe as newPasswordSchema,
  N as parseLocalDate,
  Ae as resetPasswordSchema,
  ne as scrollToSection,
  ie as setPreferredDashboardView,
  ve as setSentryFormContext,
  Ue as setSentryUserContext,
  Te as signInSchema,
  pe as signUpSchema,
  se as soundUtils,
  oe as typography,
  Me as unconfirmedAccountManager,
  Ne as useMediaQuery,
  Se as usePasswordValidator
};
